<template>
  <nav class="c-nav c-nav--illustrations">
    <button
      @click="changeIllustration(-1)"
      @keyup.enter="changeIllustration(-1)"
      type="button"
      class="c-btn c-btn--invisible has-icon c-btn--vert-center"
      aria-label="Vis forrige illustrasjon"
    >
      <icon-left
        class="c-nav__icon c-nav__icon--big"
      />
    </button>
    <span>
      {{ index + 1 }}/{{ illustrationIds.length }}
    </span>
    <button
      @click="changeIllustration(1)"
      @keyup.enter="changeIllustration(1)"
      type="button"
      class="c-btn c-btn--invisible has-icon c-btn--vert-center"
      aria-label="Vis neste illustrasjon"
    >
      <icon-right
        class="c-nav__icon c-nav__icon--big"
      />
    </button>
  </nav>
</template>

<script>
import Building from '@/models/Building';
import Illustration from '@/models/Illustration';

import IconLeft from '@/components/icons/IconLeft.vue';
import IconRight from '@/components/icons/IconRight.vue';

export default {
  name: 'IllustrationNavigation',
  components: {
    IconLeft,
    IconRight,
  },
  props: {
    illustrationIds: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      index: 0,
    };
  },
  computed: {
    activeIllustrationId() {
      return this.$store.state.entities.illustrations.activeIllustration;
    },
  },
  watch: {
    activeIllustrationId() {
      this.findActiveIllustration();
    },
  },
  mounted() {
    this.findActiveIllustration();
  },
  methods: {
    findActiveIllustration() {
      this.illustrationIds.forEach((id, index) => {
        if (id === this.activeIllustrationId) {
          this.index = index;
        }
      });
    },
    changeIllustration(int) {
      // Update index and loop around max length og illustrationsIds array.
      if (this.index + int < 0) {
        this.index = parseInt(this.illustrationIds.length + int);
      } else {
        this.index = parseInt((this.index + int) % this.illustrationIds.length);
      }
      Illustration.commit( state => {
        state.activeIllustration = this.illustrationIds[this.index];
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.screen-reader-text {
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
  -webkit-clip-path: inset(50%);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute !important;
  width: 1px;
  word-wrap: normal !important;
}
</style>